import { render, staticRenderFns } from "./sale-admin-costModification-popup.vue?vue&type=template&id=6ffc732b"
import script from "./sale-admin-costModification-popup.vue?vue&type=script&lang=js"
export * from "./sale-admin-costModification-popup.vue?vue&type=script&lang=js"
import style0 from "./sale-admin-costModification-popup.vue?vue&type=style&index=0&id=6ffc732b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports